import { plansapi } from "utilities/Axios";

export const getPlans = () => {
    return plansapi.get("/api/Plan");
};

export const postPlan = (data: any) => {
    return plansapi.post("/api/Plan", data);
};

export const deletePlan = (id: string) => {
    return plansapi.delete(`/api/Plan/${id}`);
};

export const getPlan = (id: string) => {
    return plansapi.get(`/api/Plan/${id}`);
};

export const editPlan = (id: string, data: any) => {
    return plansapi.put(`/api/Plan/${id}`, data);
};

export const editProduct = (id: string, data: any) => {
    return plansapi.put(`/api/Plan/EditProduct/${id}`);
};

export const addProduct = (id: string, data: any) => {
    return plansapi.post(`/api/Plan/AddProduct/${id}`);
};